import axios from 'axios';
import moment from 'moment';
import { Fragment, useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as FaIcons from 'react-icons/fa';
import * as IoIcons from 'react-icons/io';
import DeletePayrollPic from './DeletePayrollPic';
import EditPayrollPic from './EditPayrollPic';
import EditIcon from '../../images/edit-icon.svg';
// import Chip from "@material-ui/core/Chip";

const PayrollPicList = ({ payrollDetails, showEdit, token}) => {
    const [payrollPicInfo, setPayrollPicInfo] = useState([])

    const [rowData, setRowData] = useState([])

    const [editPayrollPic, setOpenEditPayrollPic] = useState(false)
    const handleEditPayrollPic = () => setOpenEditPayrollPic(!editPayrollPic)

    const [deletePayrollPic, setOpenDeletePayrollPic] = useState(false)
    const handleDeletePayrollPic = () => setOpenDeletePayrollPic(!deletePayrollPic)
    
    const { REACT_APP_API_BACKEND_URL } = process.env;
    
    // Edit Group
    const editPayrollPicInfo = async (group) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/resignation/updatepayrollpics';
        const groupDetails = {
            status: group.status,
            payroll_id: group.payrollPicId,
            factory_ids: group.factoryId,
            modified_by: group.modifiedBy,
        }

        axios.post(url, groupDetails)
        .then(response =>{
            console.log(response);
            if(response.status === 200){
                if(group.status == "0" && group.isLastItem){
                    alert('Payroll Pic(s) Details has been successfully deleted!');
                } else if(group.status == "1"){
                    alert('Payroll Pic Details has been successfully modified!');
                }
            }
        },
        setTimeout(()=>{
            if(group.status == "0"){
                setOpenDeletePayrollPic(!deletePayrollPic)
            }else if(group.status == "1"){
                setOpenEditPayrollPic(!editPayrollPic)
            }
            }, 500),
            setTimeout(()=>{
                window.location.reload()
            }, 1000)
        )
        .catch(err => console.error(err)
        );
    };

    function optionsFormatter(cell, row, rowIndex, formatExtraData) {
        return (
            <Fragment>
                {showEdit &&
                    <img 
                        src={EditIcon} 
                        className='table-icon'
                        style={{minWidth: '60px'}} 
                        onClick={() => {handleEditPayrollPic(); setPayrollPicInfo(row)}}
                        alt=''
                    />
                }
            </Fragment>
        ); 
    } 

    const columns = [
        { dataField: 'name', 
            text: 'Payroll Name', 
            sort: true, 
            attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' } 
        },
        { dataField: 'factories', text: 'Factories', sort: true,
            headerStyle: { textAlign: 'center' },  
            attrs: { width: 250 }, 
            style: { textAlign: 'center' },
            formatter: (cell,row) => {
                var factories = [];
                for(var i = 0; i < row.factories.length; i++) {
                    factories.push(row.factories[i].factory);
                }
                var factoryList = factories.join(', ');
                return `${factoryList}`
            },
        },
        { dataField: 'modifiedDate', text: 'Modified Date', sort: true,
            attrs: { width: 160 },
            formatter: (cell,row) => {
                return <>{moment(row.modified_date).format('DD MMM YYYY')}</>
            }
        },
        { dataField: 'edit',
            text: 'Options',
            sort: false,
            formatter: optionsFormatter,
            headerAttrs: { width: 50 },
            attrs: { width: 50, className: "EditRow" }
        }
    ]

    const selectRow = {
        mode: 'checkbox',
        onSelect: (row, isSelect, rowIndex, e) => {
            if (isSelect === true) {
                setRowData((rowData) => [...rowData, row]);
            } else {
                setRowData((rowData) => rowData.filter((item) => item !== row.id));
            }
        },
        onSelectAll: (isSelect, rows, e) => {
            if (isSelect === true) {
                setRowData(rows);
            } else {
                setRowData([]);
            }
        }
    };

    const { SearchBar, ClearSearchButton } = Search;

    return (
        <Fragment>
            <ToolkitProvider
                keyField='id'
                data={payrollDetails}
                columns={columns}
                search={{ searchFormatted: true }}
            >
            {
                props => (
                <div style={{marginTop: '10px'}}>
                    <SearchBar { ...props.searchProps } />
                    <ClearSearchButton { ...props.searchProps } />
                    {
                        rowData.length > 0 &&
                        <Button 
                            variant='outline-danger' 
                            onClick={() => {handleDeletePayrollPic()}} 
                            style={{float:'right'}}>
                            <FaIcons.FaTrashAlt size={25} />
                        </Button>
                    }
                    {showEdit ?
                    <BootstrapTable
                        classes='infohub-table'
                        bordered={false}
                        { ...props.baseProps }
                        pagination={paginationFactory()}
                        selectRow={selectRow}
                        headerWrapperClasses='infohub-header'
                        noDataIndication='List is empty.'
                    />
                    :
                    <BootstrapTable
                        classes='infohub-table'
                        bordered={false}
                        { ...props.baseProps }
                        pagination={paginationFactory()}
                        headerWrapperClasses='infohub-header'
                        noDataIndication='List is empty.'
                    />
                    }
                    <EditPayrollPic
                        show={editPayrollPic}
                        handleClose={handleEditPayrollPic}
                        modalInfo={payrollPicInfo}
                        onEdit={editPayrollPicInfo}
                        token={token}
                    />
                    <DeletePayrollPic
                        show={deletePayrollPic}
                        handleClose={handleDeletePayrollPic}
                        modalInfo={payrollPicInfo}
                        rowData={rowData}
                        onDelete={editPayrollPicInfo}
                    />
                </div>
                )
            }
            </ToolkitProvider>
        </Fragment>
    );
};

export default PayrollPicList;
